/**
 * Locale constants, kept free of any `translation.json` import so they can be
 * pulled into server bundles (e.g. Next.js API routes) without dragging in the
 * ~1.3MB of dictionaries. The package entry (`index.ts`) re-exports these, so
 * there is a single source of truth; import from `@ergon-ai/dictionaries/locales`
 * when you only need the list, not the translations.
 */

export const locales = ["en-GB", "it-IT", "de-DE", "nl-NL", "fr-FR", "es-ES"];

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en-GB";
